"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _moment = _interopRequireDefault(require("moment"));
require("moment-timezone");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component(props) {
    var _this;
    _classCallCheck(this, Component);
    _this = _callSuper(this, Component, [props]);
    _defineProperty(_this, "state", {
      info: {},
      showPackages: false,
      version: false,
      versionDate: false
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.getAppInfo();
    });
    _defineProperty(_this, "getAppInfo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, _this$parseVersion, version, versionDate;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('appdefs.debug.about'));
          case 1:
            response = _context.v;
            _this$parseVersion = _this.parseVersion(response.data.data.composerLock.packages), version = _this$parseVersion.version, versionDate = _this$parseVersion.versionDate;
            _this.setState({
              info: response.data.data,
              version: version,
              versionDate: versionDate
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "parseVersion", function (packages) {
      var appdef = packages.filter(function (p) {
        return p.name.startsWith('cccisd/app-definitions');
      });
      var version = false;
      var versionDate = false;
      if (appdef.length > 0) {
        if (appdef[0].version) {
          version = appdef[0].version;
        }
        if (appdef[0].time) {
          versionDate = appdef[0].time;
        }
      }
      return {
        version: version,
        versionDate: versionDate
      };
    });
    _defineProperty(_this, "renderVersion", function () {
      var _this$state = _this.state,
        info = _this$state.info,
        version = _this$state.version,
        versionDate = _this$state.versionDate;
      var tzName = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableWrap
      }, /*#__PURE__*/_react["default"].createElement("h2", null, info.appname ? info.appname : 'Software'), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "App Version"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.version ? info.version : 'Local', info.versionDate && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].extraDetail
      }, (0, _moment["default"])(info.versionDate).local().tz(tzName).format('dddd MMMM D, YYYY h:mma z')))), info.builderTag && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label,
        rowSpan: "3"
      }, "Builder Version"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, "Tag", /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].extraDetail
      }, info.builderTag))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, "PHP", /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].extraDetail
      }, info.builderPhp))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, "Node", /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].extraDetail
      }, info.builderNode)))), version && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Platform Version"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, version, versionDate && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].extraDetail
      }, (0, _moment["default"])(versionDate).local().tz(tzName).format('dddd MMMM D, YYYY h:mma z')))))));
    });
    _defineProperty(_this, "renderPackages", function () {
      var info = _this.state.info;
      if (!info.composerLock && !info.packageLock) {
        return false;
      }
      if (!_this.state.showPackages) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].showHide
        }, /*#__PURE__*/_react["default"].createElement("a", {
          onClick: _this.toggleShowPackages
        }, "Show packages..."));
      }
      var composerList = info.composerLock.packages.filter(function (p) {
        return p.name.startsWith('cccisd/');
      }).map(function (val, index) {
        var namesplit = val.name.split('/');
        var packageUrl = val.source.url.split(':')[1].split('.')[0];
        var url = "https://git.3cisd.com/".concat(packageUrl, "/tree/").concat(val.version);
        var frontendLink = false;
        if (val.extra && val.extra.npmDependencies && Object.entries(val.extra.npmDependencies).length) {
          var dep = Object.entries(val.extra.npmDependencies)[0];
          var depVer = dep[1];
          var depName = dep[0].replace('cccisd-laravel-', '').replace('cccisd-', '');
          var prefix = dep[0].startsWith('cccisd-laravel-') ? 'cccisd-laravel-' : 'cccisd-';
          var depUrl = "https://git.3cisd.com/react-components/base-packages/tree/".concat(dep[0], "@").concat(depVer, "/packages/").concat(dep[0]);
          frontendLink = /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].frontEnd
          }, "\u2192 ", /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].cccisd
          }, prefix), depName, ":", ' ', /*#__PURE__*/_react["default"].createElement("a", {
            href: depUrl,
            target: "_BLANK",
            rel: "noopener noreferrer"
          }, depVer));
        }
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: index
        }, /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].label
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].cccisd
        }, "".concat(namesplit[0], "/")), namesplit[1]), /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].value
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: url,
          target: "_BLANK",
          rel: "noopener noreferrer"
        }, val.version), frontendLink));
      });
      var appGitUrl = false;
      if (info.version && info.gitname) {
        appGitUrl = "https://git.3cisd.com/laravel-applications/".concat(info.gitname, "/tree/").concat(info.version);
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableWrap
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Packages"), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null), /*#__PURE__*/_react["default"].createElement("tbody", null, appGitUrl && /*#__PURE__*/_react["default"].createElement("tr", {
        className: _style["default"].highlightRow
      }, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].cccisd
      }, "laravel-applications/"), info.gitname), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: appGitUrl
      }, info.version))), composerList))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].showHide
      }, /*#__PURE__*/_react["default"].createElement("a", {
        onClick: _this.toggleShowPackages
      }, "Hide packages...")));
    });
    _defineProperty(_this, "renderDeployment", function () {
      var info = _this.state.info;
      if (info.appenv === 'local') {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tableWrap
        }, /*#__PURE__*/_react["default"].createElement("h2", null, "Tools"), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].label
        }, "Logs"), /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].value
        }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          className: "btn-sm btn-primary",
          title: "Laravel",
          onClick: _this.goLaravel
        }))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].label
        }, "Debug"), /*#__PURE__*/_react["default"].createElement("td", {
          className: _style["default"].value
        }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          className: "btn-sm btn-primary",
          title: "GraphiQL",
          onClick: _this.goGraphiQL
        }))))));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableWrap
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Deployment"), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null), /*#__PURE__*/_react["default"].createElement("tbody", null, info.deploymentContainer && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Container"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.deploymentContainer)), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Method"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.deploymentMethod ? info.deploymentMethod : 'Development Servers')), info.deploymentHost && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Host"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.deploymentHost)), info.deploymentQueue && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Queue"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.deploymentQueue)), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Logs"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.sentry && /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn-sm btn-primary",
        title: "Sentry",
        onClick: _this.goSentry
      }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn-sm btn-primary",
        title: "Laravel",
        onClick: _this.goLaravel
      }))))));
    });
    _defineProperty(_this, "renderMessaging", function () {
      var info = _this.state.info;
      var mailHost = 'Off';
      if (info.mailHost === true) {
        mailHost = 'Live';
      } else if (info.mailHost !== false) {
        mailHost = info.mailHost;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableWrap
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Messaging"), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Email Method"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, mailHost)), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "Email From"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.mailFromName, " <", info.mailFromAddress, ">")), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].label
      }, "SMS Method"), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].value
      }, info.smsLogOnly && 'Log Only' || 'Live')))));
    });
    _defineProperty(_this, "toggleShowPackages", function () {
      _this.setState({
        showPackages: !_this.state.showPackages
      });
    });
    _defineProperty(_this, "goSentry", function () {
      window.open(_this.state.info.sentry, 'sentry');
    });
    _defineProperty(_this, "goLaravel", function () {
      window.open('laravel', 'laravel');
    });
    _defineProperty(_this, "goGraphiQL", function () {
      window.open('../api/graphiql', 'graphiql');
    });
    _this.toggleShowPackages = _this.toggleShowPackages.bind(_this);
    _this.goSentry = _this.goSentry.bind(_this);
    _this.goLaravel = _this.goLaravel.bind(_this);
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].about
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableContain
      }, this.renderVersion(), this.renderPackages(), this.renderDeployment(), this.renderMessaging()));
    }
  }]);
}(_react["default"].Component);